<div class="d-flex align-items-center gap-2">
    <label *ngIf="label" class="form-label mb-0 text-nowrap">{{ label | translate }}</label>
    <input type="color" [(ngModel)]="modelValue" (ngModelChange)="modelValueChange.emit($event)" class="form-control form-control-color" [attr.disabled]="disabled ? true : null" [attr.required]="required ? true : null" [attr.name]="name" [attr.id]="id" [attr.title]="title" />
</div>
